import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import Swal from 'sweetalert2'
import {
  Row,
  Col,
  FormGroup,
  Input,
  Button
} from 'reactstrap';

export default class ForgetPassowrd extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "", code_info: "Click to get!", code: "" };
  }

  resetPassword() {
    let storage = window.localStorage;
    axios.post(storage.ch_action_url + "/action/reset_user_password", Qs.stringify({
      email: this.state.email,
      password: this.state.password,
      code: this.state.code
    })).then(res => {
      console.log(res);
      if (res.data.status === 0) {
        Swal.fire(
          'Error',
          res.data.info,
          'error');
      }
      else {
        Swal.fire(
          'Good Job!',
          "Your new password has been reset!",
          'success').then((result) => {
            window.location.href= window.location.origin + "/" + window.localStorage.ch_domain_name + "/home/all";
          });
      }

    }).catch(error => {
      console.log(error);
    });
  }

  handleGetValidationCode() {
    let storage = window.localStorage;
    let email =this.state.email;
    if (email === "") {
      Swal.fire(
        'Incorrect Information',
        'Please input correct email address!',
        'error');
      return;
    }
    this.setState({ code_info: "sending code..." })
    axios.post(storage.ch_action_url + "/action/get_temp_password_code", Qs.stringify({
      email: email
    })).then(res => {
      console.log(res);
      this.setState({ code_info: "Click to get" })
      if (res.data.status === 0) {
        Swal.fire(
          'Error',
          res.data.info,
          'error');
      }
      else {
        Swal.fire(
          'Good Job',
          'The validation code has been sent to your email!',
          'success');

      }

    }).catch(error => {
      console.log(error);
    });
  }

  render() {
    return (
      <Fragment>
        <div className="app-wrapper min-vh-100">
          <div className="app-main min-vh-100">
            <div className="app-content p-0">
              <div className="app-content--inner d-flex align-items-center">
                <div className="flex-grow-1 w-100 d-flex align-items-center">
                  <div className="bg-composed-wrapper--content py-5">
                    <div className="pl-0 pl-md-5" style={{ maxWidth: '600px', margin: "auto" }}>
                      <div className="text-black mt-3">
                        <span className="text-left text-sm-center">
                          <h1 className="display-3 text-lg-left text-center mb-3 font-weight-bold">
                            {"Reset Password!"}
                          </h1>
                        </span>
                        <div>
                          <form>
                            <FormGroup>
                              <label>{"Email"}</label>
                              <Input
                                placeholder="yourname@yourmail.com"
                                type="email"
                                onChange={(event) => { this.setState({ email: event.target.value }) }}
                                value={this.state.email}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label>Validation Code</label><span onClick={() => this.handleGetValidationCode()} className="ml-3 text-warning" style={{ cursor: "pointer" }}>{this.state.code_info}</span>
                              <Input
                                id="verfication_code"
                                placeholder="Enter your code"
                                type="text" value={this.state.code} onChange={(e) => this.setState({ code: e.target.value })}
                              />
                            </FormGroup>
                            <div className="form-group mb-4">
                              <div className="d-flex justify-content-between">
                                <label>{"New Password"}</label>
                              </div>
                              <Input
                                //placeholder="Enter your password"
                                type="password"
                                onChange={(event) => { this.setState({ password: event.target.value }) }}
                                value={this.state.password}
                              />
                            </div>

                            <Button size="lg" block={true} color="second" onClick={() => { this.resetPassword() }}>
                              {"Submit"}
                            </Button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
